
import { defineComponent, ref } from 'vue';
import TelaPadraoCrud from '@/core/components/TelaPadraoCrud.vue';
import { useCrudBase } from '@/core/composables/CrudBase';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import { EPermissaoDados } from '@/models/Enumeradores/MeuSistema/Usuarios/EPermissaoDados';
import ServicoVeiculoCor from '@/servicos/Cadastros/Veiculo/ServicoVeiculoCor';
import VeiculoCorModal from './VeiculoCorModal.vue';

export default defineComponent({
  name: 'VeiculoCor',
  components: {
    TelaPadraoCrud,
    VeiculoCorModal,
  },
  setup() {
    const {
      crudBase, preencherEstrutura, exibirModal, sincronizaTelaCrud, preencherCamposOrdenacao,
    } = useCrudBase();

    const servicoVeiculoCor = new ServicoVeiculoCor();
    const refCrud = ref<InstanceType<typeof TelaPadraoCrud>>();

    crudBase.estrutura = preencherEstrutura();
    crudBase.estrutura.apresentarEmpresas = true;
    crudBase.estrutura.verificarCadastroCompartilhado = true;
    crudBase.estrutura.botaoPrincipalAcao = 'Nova';
    crudBase.estrutura.mensagemExclusao = 'Você confirma a exclusão da cor do veículo:';
    crudBase.estrutura.colunasGrade = [
      {
        title: 'Código', dataIndex: 'codigo', key: 'Codigo', position: 0, visible: false, ordering: true,
      },
      {
        title: 'Descrição', dataIndex: 'descricao', key: 'DescricaoCor', position: 1, visible: true, ordering: true, fixed: 'left', align: 'left', customRenderRow: ECustomRenderRow.LinkAcao,
      },
      {
        title: 'Cor Denatran', dataIndex: 'corDenatran', key: 'CorDenatran', position: 2, visible: true, align: 'left', ordering: true,
      },
      {
        title: 'Status', dataIndex: 'ativo', key: 'Ativo', position: 3, visible: true, align: 'left', width: 100, customRenderRow: ECustomRenderRow.TagAtiva,
      },
      {
        title: 'Ações', key: 'acoes', position: 4, visible: true, fixed: 'right', width: 100, align: 'center', customRenderRow: ECustomRenderRow.IconeAcoes,
      },
    ];
    crudBase.estrutura.ordenacaoPadraoGrade = preencherCamposOrdenacao();

    async function sincronizarRegistro(acao: EPermissaoDados, codigoRegistro: number) {
      if (refCrud.value !== undefined) {
        await refCrud.value.sincronizarRegistro(acao, codigoRegistro);
      }
    }

    return {
      crudBase,
      servicoVeiculoCor,
      refCrud,
      exibirModal,
      sincronizaTelaCrud,
      sincronizarRegistro,
    };
  },
});
